import { Stack } from "expo-router";
import { observer } from "mobx-react";
import { Header } from "~/components/Header";

const AuthLayout = observer(function AuthLayout() {
  return (
    <>
      <Stack
        initialRouteName="booking-login"
        screenOptions={{
          header: (props) => <Header {...props} />,
          freezeOnBlur: false,
          animation: "slide_from_right",
          headerShown: false,
        }}
      >
        <Stack.Screen
          name="booking-login"
          options={{
            headerShown: false,
          }}
        />

        <Stack.Screen
          name="booking"
          options={{
            headerShown: false,
          }}
        />
      </Stack>
    </>
  );
});

export default AuthLayout;
